import React, { useState, useEffect } from "react";
import { BaseURL, postData, putData } from "../FatchApi/FatchApi";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import "draft-js/dist/Draft.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import Spinner from "./Loader/Spinner";

const BlogAddForm = ({ id }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [point, setPoint] = useState("");
  const [spinner, setSpinner] = useState(false);

  useEffect(() => {
    if (id && id.points) {
      const blocksFromHTML = convertFromHTML(id.points);
      const state = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setEditorState(EditorState.createWithContent(state));
      setPoint(id.points);
    }
  }, [id]);

  const uploadImageCallBack = (file) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("file", file);

      fetch(`${BaseURL}/api/upload`, {
        method: "POST",
        credentials: "include",
        body: formData,
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok || !data.url) throw new Error(data.error || "Upload failed");
          return data;
        })
        .then((data) => {
          resolve({ data: { link: `${BaseURL}${data.url}` } });
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    const html = draftToHtml(rawContentState);
    setPoint(html);
  };

  const convertContentToHTML = () => {
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    const html = draftToHtml(rawContentState);
    setPoint(html);
  };

  const initialFormData = {
    title: id?.title || "",
    publishDate: id?.publishDate ? id.publishDate.split("T")[0] : "",
    metaTitle: id?.metaTitle || "",
    metaDescription: id?.metaDescription || "",
    metaKeywords: id?.metaKeywords || "",
    slug: id?.slug || "",
    paragraph: id?.paragraph || "",
    images: [],
  };

  const [productData, setProductData] = useState(initialFormData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    const fileArray = Array.from(files);
    setProductData((prevData) => ({
      ...prevData,
      images: fileArray,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSpinner(true);
    
    const formData = new FormData();
    formData.append("title", productData.title);
    formData.append("metaTitle", productData.metaTitle);
    formData.append("metaDescription", productData.metaDescription);
    formData.append("metaKeywords", productData.metaKeywords);
    formData.append("publishDate", productData.publishDate);
    formData.append("slug", productData.slug);
    formData.append("paragraph", productData.paragraph);
    formData.append("points", point);
    
    if (productData.images && productData.images.length > 0) {
      productData.images.forEach((image) => {
        formData.append(`images`, image);
      });
    }

    if (id && id._id) {
      const res = await putData(`api/blog/update-blogs/${id._id}`, {
        data: formData
      });
      
      if (res && (res.success || res._id)) {
        setSpinner(false);
        alert("Blog updated successfully!");
        window.location.reload();
      } else {
        setSpinner(false);
        alert(res?.message || "Error updating blog");
      }
    } else {
      const res = await postData("api/blog/add-blog", {
        data: formData
      });
      
      if (res.success) {
        setSpinner(false);
        alert("Blog added successfully!");
        window.location.reload();
      } else {
        setSpinner(false);
        alert(res?.message || "Error adding blog");
      }
    }
  };

  return (
    <>
      {spinner ? <Spinner /> : ""}
      <form encType="multipart/form-data" onSubmit={handleSubmit}>
        <div className="grid grid-cols-2 gap-4 mx-auto">
          <div className="mb-4">
            <label htmlFor="title" className="block mb-1 font-medium">
              Blog Title
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded"
              id="title"
              name="title"
              placeholder="Title"
              value={productData.title}
              onChange={handleChange}
              required
            />
          </div>

          {/* <div className="mb-4">
        <label htmlFor="productDescription" className="block mb-1 font-medium">
          Blog Description
        </label>
        <textarea
          className="w-full px-3 py-2 border border-gray-300 rounded bg-light"
          rows="3"
          placeholder="Enter product description"
          id="productDescription"
          name="description"
          value={productData.description}
          onChange={handleChange}
          required
        ></textarea>
      </div> */}

          <div className="mb-4">
            <label htmlFor="sku" className="block mb-1 font-medium">
              Blog Paragraph
            </label>
            <input
              type="text"
              step="1"
              className="w-full px-3 py-2 border border-gray-300 rounded"
              placeholder="Paragraph "
              id="paragraph"
              name="paragraph"
              value={productData.paragraph}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="title" className="block mb-1 font-medium">
              Meta Title of Blog
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded"
              id="metaTitle"
              name="metaTitle"
              placeholder=" Meta Title "
              value={productData.metaTitle}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="title" className="block mb-1 font-medium">
              Meta Description Blog
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded"
              id="metaDescription"
              name="metaDescription"
              placeholder="Meta Description"
              value={productData.metaDescription}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="title" className="block mb-1 font-medium">
              Meta Keywords Blog
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded"
              id="title"
              name="metaKeywords"
              placeholder="Meta Keywords"
              value={productData.metaKeywords}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="mrp" className="block mb-1 font-medium">
              Blog Publish Date
            </label>
            <input
              type="Date"
              step="1"
              className="w-full px-3 py-2 border border-gray-300 rounded"
              placeholder="Blog Publish Date"
              id="publishDate"
              name="publishDate"
              value={productData.publishDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="mrp" className="block mb-1 font-medium">
              Blog Slug
            </label>
            <input
              type="text"
              step="1"
              className="w-full px-3 py-2 border border-gray-300 rounded"
              placeholder="  Blog Slug "
              id="ean"
              name="slug"
              value={productData.slug}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="image" className="block mb-1 font-medium">
              Image
            </label>

            <input
              type="file"
              id="images"
              name="images"
              onChange={handleFileChange}
              multiple
            />
          </div>
        </div>
        <div className="mb-4 bg-white">
          <Editor
            editorState={editorState}
            wrapperClassName="wrapper-class"
            editorClassName="editor-class"
            toolbarClassName="toolbar-class"
            onEditorStateChange={onEditorStateChange}
            toolbar={{
              image: {
                uploadCallback: uploadImageCallBack,
              },
            }}
          />
          <button
            type="submit"
            className="px-4 py-2 mt-5 text-white bg-blue-500 rounded hover:bg-blue-600 float-right text-center"
          >
            {id ? "Update Blog" : "Upload Blog"}
          </button>
        </div>
      </form>
    </>
  );
};

export default BlogAddForm;
